module.exports = __webpack_public_path__ + "stylesheets/wave-template-item_743c4039a4836d556ea5daf2ea0eea69.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/wave/wave-template-item.less
// module id = aTCW
// module chunks = 153